import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../components/MarginalsV2/Header';
import Footer from '../../components/MarginalsV2/Footer';
import TechFooter from '../../components/TechFooter';

const countryLoaders = {
  'japan-driving-license': (language) => import(`../JapanDrivingLicense/${language}.jsx`),
  'thailand-driving-license': (language) => import(`../ThailandDrivingLicense/${language}.jsx`),
  'italy-driving-license': (language) => import(`../ItalyDrivingLicense/${language}.jsx`),
};

const DrivingLicensePage = () => {
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const [data, setData] = useState(null);

  const pathParts = location.pathname.split('/').filter(Boolean);
  const countrySlug = pathParts[pathParts.length - 1] || '';
  const loader = countryLoaders[countrySlug];

  useEffect(() => {
    let isMounted = true;

    const loadData = async () => {
      if (!loader) {
        if (isMounted) {
          setData(null);
        }
        return;
      }

      try {
        const module = await loader(i18n.language);
        if (isMounted) {
          setData(module.default);
        }
      } catch {
        try {
          const fallback = await loader('en');
          if (isMounted) {
            setData(fallback.default);
          }
        } catch {
          if (isMounted) {
            setData(null);
          }
        }
      }
    };

    loadData();

    return () => {
      isMounted = false;
    };
  }, [i18n.language, loader]);

  if (!loader) {
    return (
      <main style={{ padding: '1rem' }}>
        <p>{t('nothing_page')}</p>
      </main>
    );
  }

  if (!data) {
    return <div>Loading...</div>;
  }

  const { config, content } = data;

  return (
    <>
      <div className="position-relative">
        <Header className="position-absolute top-0 w-100" style={{ zIndex: 10 }} />
        <section className="hero-section bg-primary text-white py-6" style={{ paddingTop: '140px' }}>
          <Container>
            <Row className="justify-content-center">
              <Col md={8} className="text-center">
                <h1 className="display-4">{config.heroTitle}</h1>
                <p className="lead">{config.heroSubtitle}</p>
                <p className="text-white-50 mt-2">{config.date}</p>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Container className="mt-5">
        <Row>
          <Col>
            {content}
          </Col>
        </Row>
      </Container>
      <Footer />
      <TechFooter />
    </>
  );
};

export default DrivingLicensePage;